// src/components/CatechistGiftRoulette.js
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import defaultGiftData from '../data/defaultGifts.json';
import birthdayWishesData from '../data/birthdayWishes.json';
import wishes2010Data from '../data/wishes2010.json';
import { 
  fetchGiftEvents,
  fetchCatechistGiftRegistration,
  saveCatechistGiftRegistration,
  fetchUserCustomGifts,
  saveUserCustomGifts,
  fetchCatechistProfile
} from '../FirebaseService';
import { auth } from '../firebaseConfig';
import './CatechistGiftRoulette.css';

const DEFAULT_GIFT_IMG = 'https://images.unsplash.com/photo-1549465220-1a8b9238cd48?auto=format&fit=crop&w=500&q=80';

// ====================================================================
// HỆ THỐNG ÂM THANH TICK ĐẦM ẤM (WEB AUDIO API)
// ====================================================================
let audioCtx = null;
let audioBuffer = null;

const getAudioContext = () => {
  if (!audioCtx) {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (AudioContextClass) audioCtx = new AudioContextClass();
  }
  if (audioCtx && audioCtx.state === 'suspended') {
    audioCtx.resume();
  }
  return audioCtx;
};

const preloadAudioBuffer = async () => {
  if (audioBuffer) return audioBuffer;
  const ctx = getAudioContext();
  if (!ctx) return null;
  const candidateUrls = ['/sounds/sounds_scroll.wav', '/sounds/csgo_ui_crate_item_scroll.wav'];
  for (const url of candidateUrls) {
    try {
      const res = await fetch(url);
      if (res.ok) {
        const arrayBuffer = await res.arrayBuffer();
        audioBuffer = await ctx.decodeAudioData(arrayBuffer);
        return audioBuffer;
      }
    } catch (e) {}
  }
  return null;
};

const playDeepTick = () => {
  try {
    const ctx = getAudioContext();
    if (!ctx || !audioBuffer) return;
    const source = ctx.createBufferSource();
    source.buffer = audioBuffer;
    source.playbackRate.value = 0.85;

    const lowpass = ctx.createBiquadFilter();
    lowpass.type = 'lowpass';
    lowpass.frequency.value = 2800;

    const bass = ctx.createBiquadFilter();
    bass.type = 'lowshelf';
    bass.frequency.value = 220;
    bass.gain.value = 4.5;

    const gainNode = ctx.createGain();
    gainNode.gain.value = 0.4;

    source.connect(lowpass);
    lowpass.connect(bass);
    bass.connect(gainNode);
    gainNode.connect(ctx.destination);
    source.start(0);
  } catch (err) {}
};

const CatechistGiftRoulette = () => {
  const navigate = useNavigate();

  // 1. Định danh GLV: Trực tiếp lấy gender & religious từ Firestore qua fetchCatechistProfile
  const currentUid = auth.currentUser?.uid || localStorage.getItem('uid');
  const [userGender, setUserGender] = useState(localStorage.getItem('gender') || 'Nam');
  const [userReligious, setUserReligious] = useState(localStorage.getItem('religious') || 'Giáo lý viên');
  const [userHolyName, setUserHolyName] = useState(localStorage.getItem('catechistHolyName') || '');
  const [userFullName, setUserFullName] = useState(localStorage.getItem('catechistFullName') || 'Giáo lý viên');
  const [userClassName, setUserClassName] = useState(localStorage.getItem('catechistClassName') || '');

  // 2. Danh sách Sự kiện
  const [eventsList, setEventsList] = useState([]);
  const [activeEventId, setActiveEventId] = useState('birthday');
  const [eventsLoading, setEventsLoading] = useState(true);

  // 3. Quà mặc định & Quà tự tạo
  const baseGifts = useMemo(() => defaultGiftData.gifts || [], []);
  const [customGifts, setCustomGifts] = useState([]);

  // 4. Trạng thái Đăng ký món quà của GLV trong sự kiện hiện tại
  const [confirmedRegistration, setConfirmedRegistration] = useState(null);
  const [loadingRegistration, setLoadingRegistration] = useState(true);

  // 5. Băng chuyền Roulette & Kéo lướt thủ công
  const [isSpinning, setIsSpinning] = useState(false);
  const [reelList, setReelList] = useState([]);
  const [currentTranslateX, setCurrentTranslateX] = useState(0);
  const [isAnimatingSpin, setIsAnimatingSpin] = useState(false);
  const [spinDurationSec, setSpinDurationSec] = useState(9.0);

  const [winnerGift, setWinnerGift] = useState(null);
  const [showWinnerModal, setShowWinnerModal] = useState(false);
  const [showManageModal, setShowManageModal] = useState(false);
  const [showWishModal, setShowWishModal] = useState(false);

  // 6. Form thêm món quà mới
  const [newGiftName, setNewGiftName] = useState('');
  const [newGiftTag, setNewGiftTag] = useState('Tự Chọn');
  const [newPurchaseUrl, setNewPurchaseUrl] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const containerRef = useRef(null);
  const trackRef = useRef(null);
  const animFrameRef = useRef(null);
  const lastCrossedIndexRef = useRef(-1);

  // Quản lý vuốt/kéo thủ công (Mouse Drag & Touch Swipe)
  const isDraggingRef = useRef(false);
  const dragStartXRef = useRef(0);
  const dragStartTranslateRef = useRef(0);
  const hasMovedRef = useRef(false);

  useEffect(() => {
    preloadAudioBuffer();
    return () => {
      if (animFrameRef.current) cancelAnimationFrame(animFrameRef.current);
    };
  }, []);

  // 🌟 LẤY TRỰC TIẾP GENDER VÀ RELIGIOUS TỪ FIRESTORE STAFF QUA FirebaseService
  useEffect(() => {
    let isMounted = true;
    const loadProfile = async () => {
      if (!currentUid) return;
      try {
        const res = await fetchCatechistProfile(currentUid);
        if (isMounted && res.success && res.data) {
          const d = res.data;
          if (d.gender) {
            setUserGender(d.gender);
            localStorage.setItem('gender', d.gender);
          }
          if (d.religious) {
            setUserReligious(d.religious);
            localStorage.setItem('religious', d.religious);
          }
          if (d.holyName !== undefined) {
            setUserHolyName(d.holyName);
            localStorage.setItem('catechistHolyName', d.holyName);
          }
          if (d.fullName) {
            setUserFullName(d.fullName);
            localStorage.setItem('catechistFullName', d.fullName);
          }
          if (d.className !== undefined) {
            setUserClassName(d.className);
            localStorage.setItem('catechistClassName', d.className);
          }
        }
      } catch (err) {
        console.error('Lỗi khi tải thông tin hồ sơ GLV từ Firestore:', err);
      }
    };

    loadProfile();
    return () => { isMounted = false; };
  }, [currentUid]);

  // Tải danh sách sự kiện từ Firestore
  useEffect(() => {
    const loadEvents = async () => {
      try {
        setEventsLoading(true);
        const remoteEvents = await fetchGiftEvents();
        const now = new Date().toISOString();

        // Lọc bỏ sự kiện đã quá ngày kết thúc (endDate)
        const validEvents = remoteEvents.filter(ev => {
          if (!ev.endDate) return true;
          return ev.endDate >= now;
        });

        // Tab Mặc định Sinh Nhật (Luôn có sẵn)
        const defaultBirthdayEvent = {
          id: 'birthday',
          title: '🎂 Quà Sinh Nhật',
          type: 'birthday',
          isDefault: true,
          description: 'Món quà chúc mừng sinh nhật ý nghĩa dành cho Giáo Lý Viên'
        };

        // 🌟 CHỈ CÓ SINH NHẬT LÀ MẶC ĐỊNH.
        // Các sự kiện khác (như 20/10, Giáng Sinh...) chỉ xuất hiện khi Admin tạo thêm từ Firestore
        const fullList = [defaultBirthdayEvent, ...validEvents.filter(e => e.id !== 'birthday')];

        setEventsList(fullList);
      } catch (err) {
        console.error('Lỗi khi tải sự kiện quà:', err);
      } finally {
        setEventsLoading(false);
      }
    };

    loadEvents();
  }, []);

  // 🌟 ĐIỀU KIỆN QUAN TRỌNG: CHỈ CÓ NỮ (GENDER === 'Nữ') MỚI THẤY TAB 20/10
  const visibleEvents = useMemo(() => {
    return eventsList.filter((ev) => {
      const is2010Event = ev.type === 'event_2010' || ev.id === 'event_2010';
      if (is2010Event) {
        return userGender === 'Nữ';
      }
      return true;
    });
  }, [eventsList, userGender]);

  // Nếu là Nam hoặc sự kiện hiện tại không còn hiển thị, tự động chuyển về Tab Sinh Nhật
  useEffect(() => {
    const isCurrentActiveVisible = visibleEvents.some(e => e.id === activeEventId);
    if (!isCurrentActiveVisible && visibleEvents.length > 0) {
      setActiveEventId(visibleEvents[0].id);
    }
  }, [visibleEvents, activeEventId]);

  const currentEvent = useMemo(() => {
    return visibleEvents.find(e => e.id === activeEventId) || visibleEvents[0] || {
      id: 'birthday',
      title: '🎂 Quà Sinh Nhật',
      type: 'birthday'
    };
  }, [visibleEvents, activeEventId]);

  const isExpiredDeadline = useMemo(() => {
    if (!currentEvent || currentEvent.isDefault || !currentEvent.deadline) return false;
    const now = new Date().toISOString();
    return now > currentEvent.deadline;
  }, [currentEvent]);

  // Tải quà tự tạo của GLV & Kết quả đã chốt của sự kiện hiện tại
  useEffect(() => {
    let isMounted = true;
    const loadUserData = async () => {
      if (!currentUid) return;
      setLoadingRegistration(true);

      const customs = await fetchUserCustomGifts(currentUid);
      if (isMounted) setCustomGifts(customs);

      const reg = await fetchCatechistGiftRegistration(activeEventId, currentUid);
      if (isMounted) {
        setConfirmedRegistration(reg);
        setLoadingRegistration(false);
      }
    };

    loadUserData();
    return () => { isMounted = false; };
  }, [currentUid, activeEventId]);

  // Toàn bộ danh sách quà (Gồm quà tự tạo + quà cơ bản hệ thống)
  const allGifts = useMemo(() => {
    return [...customGifts, ...baseGifts];
  }, [customGifts, baseGifts]);

  // Khởi tạo dải thẻ trên băng chuyền
  useEffect(() => {
    if (allGifts.length === 0) {
      setReelList([]);
      setCurrentTranslateX(0);
      return;
    }
    const initialList = [];
    for (let i = 0; i < 35; i++) {
      initialList.push(allGifts[i % allGifts.length]);
    }
    setReelList(initialList);
    setCurrentTranslateX(0);
    setIsAnimatingSpin(false);
  }, [allGifts]);

  // Đồng bộ âm thanh tick khi kim chỉ vượt qua từng thẻ
  const startRealtimeSoundSync = (totalStep) => {
    if (!containerRef.current || !trackRef.current) return;
    const containerRect = containerRef.current.getBoundingClientRect();
    const pinX = containerRect.left + containerRect.width / 2;
    const initialTrackLeft = trackRef.current.getBoundingClientRect().left;
    lastCrossedIndexRef.current = Math.floor((pinX - initialTrackLeft) / totalStep);

    const monitorScroll = () => {
      if (!trackRef.current || !containerRef.current) return;
      const currentTrackLeft = trackRef.current.getBoundingClientRect().left;
      const currentCrossedIndex = Math.floor((pinX - currentTrackLeft) / totalStep);

      if (currentCrossedIndex > lastCrossedIndexRef.current) {
        playDeepTick();
        lastCrossedIndexRef.current = currentCrossedIndex;
      }
      animFrameRef.current = requestAnimationFrame(monitorScroll);
    };

    animFrameRef.current = requestAnimationFrame(monitorScroll);
  };

  const stopRealtimeSoundSync = () => {
    if (animFrameRef.current) {
      cancelAnimationFrame(animFrameRef.current);
      animFrameRef.current = null;
    }
  };

  // QUAY NGẪU NHIÊN: CHẠY NHIỀU HƠN VÀ CHẬM HƠN (9 GIÂY)
  const handleSpin = () => {
    if (isSpinning || allGifts.length === 0 || isExpiredDeadline) return;
    getAudioContext();

    setIsSpinning(true);
    setIsAnimatingSpin(false);
    setWinnerGift(null);
    setShowWinnerModal(false);

    const totalCards = 65;
    const winningIndex = 48;
    const generatedList = [];

    for (let i = 0; i < totalCards; i++) {
      const randomItem = allGifts[Math.floor(Math.random() * allGifts.length)];
      generatedList.push({ ...randomItem, reelId: `${i}-${Date.now()}` });
    }

    const targetWinner = generatedList[winningIndex];
    setReelList(generatedList);
    setCurrentTranslateX(0);

    requestAnimationFrame(() => {
      setTimeout(() => {
        if (!containerRef.current || !trackRef.current) return;
        const containerWidth = containerRef.current.offsetWidth;
        const firstCard = trackRef.current.children[0];
        if (!firstCard) return;

        const cardWidth = firstCard.offsetWidth;
        const cardGap = 16;
        const totalStep = cardWidth + cardGap;
        const centerViewport = containerWidth / 2 - cardWidth / 2;
        const microOffset = (Math.random() - 0.5) * (cardWidth * 0.35);
        const destinationX = -(winningIndex * totalStep) + centerViewport + microOffset;

        const duration = 9.0;
        setSpinDurationSec(duration);
        setIsAnimatingSpin(true);
        setCurrentTranslateX(destinationX);

        startRealtimeSoundSync(totalStep);

        setTimeout(() => {
          stopRealtimeSoundSync();
          setWinnerGift(targetWinner);
          setIsSpinning(false);
          setIsAnimatingSpin(false);
          setShowWinnerModal(true);
        }, duration * 1000 + 80);
      }, 60);
    });
  };

  // NGƯỜI DÙNG TỰ LƯỚT / CUỘN THỦ CÔNG QUA LẠI BĂNG CHUYỀN
  const handleScrollManual = (direction) => {
    if (isSpinning || !containerRef.current || !trackRef.current) return;
    const firstCard = trackRef.current.children[0];
    const cardStep = firstCard ? firstCard.offsetWidth + 16 : 200;
    const scrollDelta = cardStep * 2;

    setCurrentTranslateX(prev => {
      let next = direction === 'left' ? prev + scrollDelta : prev - scrollDelta;
      const minX = -(trackRef.current.scrollWidth - containerRef.current.offsetWidth);
      if (next > 0) next = 0;
      if (next < minX) next = minX;
      return next;
    });
  };

  // Kéo vuốt chuột & cảm ứng
  const onDragStart = (clientX) => {
    if (isSpinning) return;
    isDraggingRef.current = true;
    dragStartXRef.current = clientX;
    dragStartTranslateRef.current = currentTranslateX;
    hasMovedRef.current = false;
  };

  const onDragMove = (clientX) => {
    if (!isDraggingRef.current || isSpinning) return;
    const diff = clientX - dragStartXRef.current;
    if (Math.abs(diff) > 5) {
      hasMovedRef.current = true;
    }
    let newTranslate = dragStartTranslateRef.current + diff;
    if (trackRef.current && containerRef.current) {
      const minX = -(trackRef.current.scrollWidth - containerRef.current.offsetWidth);
      if (newTranslate > 80) newTranslate = 80;
      if (newTranslate < minX - 80) newTranslate = minX - 80;
    }
    setCurrentTranslateX(newTranslate);
  };

  const onDragEnd = () => {
    if (!isDraggingRef.current) return;
    isDraggingRef.current = false;
    if (trackRef.current && containerRef.current) {
      const minX = -(trackRef.current.scrollWidth - containerRef.current.offsetWidth);
      if (currentTranslateX > 0) {
        setCurrentTranslateX(0);
      } else if (currentTranslateX < minX && minX < 0) {
        setCurrentTranslateX(minX);
      }
    }
  };

  // Bấm vào thẻ để chọn món
  const handleCardClick = (gift) => {
    if (isSpinning || hasMovedRef.current) return;
    if (isExpiredDeadline) return;
    setWinnerGift(gift);
    setShowWinnerModal(true);
  };

  // Chốt món quà chính thức
  const handleConfirmGiftChoice = async (giftToConfirm) => {
    if (!giftToConfirm || isExpiredDeadline) return;

    const activeUid = auth.currentUser?.uid || currentUid;
    if (!activeUid) {
      alert('Vui lòng đăng nhập lại để xác thực danh tính Giáo lý viên.');
      return;
    }

    // 🌟 PHÂN BIỆT LỜI CHÚC CHO TU SĨ VÀ GIÁO LÝ VIÊN
    const isTuSi = userReligious === 'Tu Sĩ';
    const sourceData = currentEvent.type === 'event_2010' ? wishes2010Data : birthdayWishesData;

    let wishList = [];
    if (isTuSi && sourceData.religious && sourceData.religious.length > 0) {
      wishList = sourceData.religious;
    } else if (!isTuSi && sourceData.catechist && sourceData.catechist.length > 0) {
      wishList = sourceData.catechist;
    } else {
      wishList = sourceData.wishes || [];
    }

    const randomWish = wishList[Math.floor(Math.random() * wishList.length)] || {
      title: isTuSi ? 'Hồng Ân Thánh Hiến' : 'Chúc Mừng',
      content: isTuSi
        ? 'Kính chúc Quý Tu Sĩ luôn dồi dào sức khỏe, tràn đầy niềm vui và thánh ân của Chúa Kitô!'
        : 'Nguyện xin Thiên Chúa ban muôn ơn lành và bình an cho bạn!'
    };

    const registrationData = {
      uid: activeUid,
      holyName: userHolyName || '',
      fullName: userFullName || 'Giáo lý viên',
      className: userClassName || '',
      gender: userGender || 'Nam',
      religious: userReligious || 'Giáo lý viên',
      giftId: String(giftToConfirm.id || Date.now()),
      giftName: giftToConfirm.name || '',
      giftImage: giftToConfirm.image || DEFAULT_GIFT_IMG,
      isCustom: Boolean(giftToConfirm.isCustom),
      purchaseUrl: giftToConfirm.purchaseUrl || '',
      tag: giftToConfirm.tag || 'Món Quà Yêu Thích',
      wishTitle: randomWish.title,
      wishContent: randomWish.content,
      confirmedAt: new Date().toISOString()
    };

    const res = await saveCatechistGiftRegistration(activeEventId, activeUid, registrationData);
    if (res.success) {
      setConfirmedRegistration(registrationData);
      setShowWinnerModal(false);
      setShowWishModal(true);
    } else {
      alert('Có lỗi xảy ra khi lưu lựa chọn quà: ' + (res.message || 'Thiếu quyền ghi Firestore'));
    }
  };

  // Thêm quà tự tạo (Không cần danh mục, không cần link ảnh)
  const handleAddCustomGift = async (e) => {
    e.preventDefault();
    if (!newGiftName.trim() || isSubmitting) return;

    const activeUid = auth.currentUser?.uid || currentUid;
    if (!activeUid) {
      alert('Vui lòng đăng nhập để thực hiện chức năng này.');
      return;
    }

    setIsSubmitting(true);

    const newGift = {
      id: `custom_${Date.now()}`,
      name: newGiftName.trim(),
      tag: newGiftTag.trim() || 'Tự Chọn',
      purchaseUrl: newPurchaseUrl.trim(),
      image: DEFAULT_GIFT_IMG,
      isCustom: true
    };

    const updated = [newGift, ...customGifts];
    setCustomGifts(updated);
    await saveUserCustomGifts(activeUid, updated);

    setNewGiftName('');
    setNewGiftTag('Tự Chọn');
    setNewPurchaseUrl('');
    setIsSubmitting(false);
  };

  const handleDeleteCustomGift = async (id) => {
    const activeUid = auth.currentUser?.uid || currentUid;
    const updated = customGifts.filter(g => g.id !== id);
    setCustomGifts(updated);
    if (activeUid) {
      await saveUserCustomGifts(activeUid, updated);
    }
  };

  const reelTrackStyle = useMemo(() => {
    if (isAnimatingSpin) {
      return {
        transform: `translateX(${currentTranslateX}px)`,
        transition: `transform ${spinDurationSec}s cubic-bezier(0.12, 0.82, 0.2, 1)`,
        cursor: 'default'
      };
    }
    return {
      transform: `translateX(${currentTranslateX}px)`,
      transition: isDraggingRef.current ? 'none' : 'transform 0.25s ease-out',
      cursor: isDraggingRef.current ? 'grabbing' : 'grab'
    };
  }, [isAnimatingSpin, currentTranslateX, spinDurationSec]);

  const fullDisplayName = `${userHolyName} ${userFullName}`.trim();

  return (
    <div className="gift-page-wrapper">
      <div className="gift-bg-glow glow-1"></div>
      <div className="gift-bg-glow glow-2"></div>
      <div className="gift-bg-glow glow-3"></div>

      <div className="gift-main-container">
        {/* TOP BAR */}
        <div className="gift-top-bar">
          <button className="gift-back-btn" onClick={() => navigate('/main')}>
            ⬅ Quay lại trang chủ
          </button>
          <div className="gift-user-chip">
            <span>{userReligious === 'Tu Sĩ' ? '✝️ Tu Sĩ:' : '👨‍🏫 GLV:'}</span>
            <strong>{fullDisplayName || (userReligious === 'Tu Sĩ' ? 'Quý Tu Sĩ' : 'Giáo lý viên')}</strong>
            <small>({userGender === 'Nữ' ? 'Nữ' : 'Nam'}{userClassName ? ` • ${userClassName}` : ''})</small>
          </div>
        </div>

        {/* HEADER */}
        <header className="gift-header">
          <span className="gift-badge-pill">🎁 Hộp Quà Bất Ngờ Ban Giáo Lý 🎁</span>
          <h1 className="gift-title">Món Quà Yêu Thích Của Bạn</h1>
          <p className="gift-desc">
            Quay ngẫu nhiên hoặc tự lướt băng chuyền để chọn món quà bạn thích nhất nhé!
          </p>
        </header>

        {/* 1. TABS SỰ KIỆN: CHỈ HIỂN THỊ CÁC SỰ KIỆN PHÙ HỢP (NỮ MỚI THẤY 20/10) */}
        <nav className="gift-event-tabs">
          <ul className="gift-tabs-list">
            {visibleEvents.map(ev => (
              <li key={ev.id} className="gift-tab-item">
                <button
                  type="button"
                  className={`gift-tab-btn ${activeEventId === ev.id ? 'active' : ''}`}
                  onClick={() => {
                    if (!isSpinning) {
                      setActiveEventId(ev.id);
                      setWinnerGift(null);
                      setShowWinnerModal(false);
                    }
                  }}
                  disabled={isSpinning}
                >
                  {ev.title}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        {/* 2. BANNER TRẠNG THÁI SỰ KIỆN & MÓN ĐÃ CHỐT */}
        <div className="gift-status-card">
          <div className="gift-status-header">
            <div className="status-title-wrap">
              <h3>{currentEvent.title}</h3>
              <p>{currentEvent.description}</p>
            </div>
            {confirmedRegistration ? (
              <span className="status-chip-done">✓ Bạn đã đăng ký quà</span>
            ) : (
              <span className="status-chip-pending">Chưa chốt quà</span>
            )}
          </div>

          {isExpiredDeadline && (
            <div className="gift-expired-warning">
              ⏰ Sự kiện này đã hết hạn đăng ký quà. Bạn không thể quay hoặc đổi món quà khác.
            </div>
          )}

          {/* HIỂN THỊ MÓN ĐÃ CHỐT NẾU CÓ */}
          {confirmedRegistration ? (
            <div className="gift-confirmed-banner">
              <div className="confirmed-thumb-wrap">
                <img
                  src={confirmedRegistration.giftImage || DEFAULT_GIFT_IMG}
                  alt={confirmedRegistration.giftName}
                  onError={(e) => { e.target.src = DEFAULT_GIFT_IMG; }}
                />
              </div>
              <div className="confirmed-details">
                <span className="confirmed-tag">✓ MÓN QUÀ BẠN ĐÃ CHỌN</span>
                <h4>{confirmedRegistration.giftName}</h4>
                <div className="confirmed-meta">
                  {confirmedRegistration.purchaseUrl && (
                    <a 
                      href={confirmedRegistration.purchaseUrl} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="confirmed-link-btn"
                    >
                      🔗 Xem link mua hàng
                    </a>
                  )}
                  <span>• Chốt ngày: {new Date(confirmedRegistration.confirmedAt).toLocaleDateString('vi-VN')}</span>
                </div>
              </div>
              <button
                type="button"
                className="view-wish-btn"
                onClick={() => setShowWishModal(true)}
              >
                💌 Xem Lời Chúc
              </button>
            </div>
          ) : (
            <div className="gift-not-confirmed-hint">
              {isExpiredDeadline 
                ? 'Bạn chưa kịp đăng ký món quà nào cho sự kiện này.'
                : '✨ Bạn có thể tự lướt xem các món hoặc bấm nút quay ngẫu nhiên bên dưới nhé!'}
            </div>
          )}
        </div>

        {/* 3. BĂNG CHUYỀN ROULETTE HỖ TRỢ KÉO VUỐT THỦ CÔNG */}
        <div className="gift-reel-container-outer">
          {/* Nút lướt sang trái */}
          <button 
            type="button" 
            className="gift-nav-arrow arrow-left"
            onClick={() => handleScrollManual('left')}
            disabled={isSpinning}
            title="Lướt sang trái"
          >
            ◀
          </button>

          <div 
            className="gift-reel-viewport" 
            ref={containerRef}
            onMouseDown={(e) => onDragStart(e.clientX)}
            onMouseMove={(e) => onDragMove(e.clientX)}
            onMouseUp={onDragEnd}
            onMouseLeave={onDragEnd}
            onTouchStart={(e) => onDragStart(e.touches[0].clientX)}
            onTouchMove={(e) => onDragMove(e.touches[0].clientX)}
            onTouchEnd={onDragEnd}
          >
            <div className="gift-center-pin">
              <div className="pin-arrow-down"></div>
              <div className="pin-line"></div>
              <div className="pin-arrow-up"></div>
            </div>

            {allGifts.length === 0 ? (
              <div className="gift-no-data">Chưa có món quà nào trong danh sách.</div>
            ) : (
              <div className="gift-reel-track" ref={trackRef} style={reelTrackStyle}>
                {reelList.map((item, idx) => (
                  <div
                    key={item.reelId || idx}
                    className={`gift-card ${item.isCustom ? 'is-custom' : ''}`}
                    onClick={() => handleCardClick(item)}
                    title="Bấm để chọn món quà này"
                  >
                    <div className="gift-card-top">
                      <span className="gift-card-tag">{item.tag || 'Món Quà'}</span>
                      {item.purchaseUrl && <span className="gift-has-link">🔗 Link</span>}
                    </div>
                    <div className="gift-card-img-wrap">
                      <img
                        src={item.image || DEFAULT_GIFT_IMG}
                        alt={item.name}
                        onError={(e) => { e.target.src = DEFAULT_GIFT_IMG; }}
                        loading="lazy"
                        draggable={false}
                      />
                    </div>
                    <div className="gift-card-name-wrap">
                      <p className="gift-card-name">{item.name}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Nút lướt sang phải */}
          <button 
            type="button" 
            className="gift-nav-arrow arrow-right"
            onClick={() => handleScrollManual('right')}
            disabled={isSpinning}
            title="Lướt sang phải"
          >
            ▶
          </button>
        </div>

        <div className="gift-drag-hint">
          <span>🖐️ Bạn có thể tự lướt để tìm món quà yêu thích</span>
        </div>

        {/* 4. NÚT ĐIỀU KHIỂN CHÍNH */}
        <div className="gift-actions-group">
          <button
            className="gift-spin-btn"
            onClick={handleSpin}
            disabled={isSpinning || allGifts.length === 0 || isExpiredDeadline}
          >
            {isSpinning ? '🎡 ĐANG QUAY CHẬM RÃI...' : '🎈 QUAY NGẪU NHIÊN'}
          </button>

          <button
            className="gift-manage-btn"
            onClick={() => setShowManageModal(true)}
            disabled={isSpinning}
          >
            ✏️ Thêm Món Quà Bạn Thích ({customGifts.length})
          </button>
        </div>

        {/* 5. MODAL KẾT QUẢ KHI QUAY HOẶC CHỌN MÓN */}
        {showWinnerModal && winnerGift && (
          <div className="gift-modal-overlay" onClick={() => setShowWinnerModal(false)}>
            <div className="gift-winner-modal" onClick={e => e.stopPropagation()}>
              <button
                type="button"
                className="modal-close-btn"
                onClick={() => setShowWinnerModal(false)}
              >
                ✕
              </button>
              <div className="winner-confetti">🎉 🎁 ✨</div>
              <span className="winner-sub-title">Món quà được chọn:</span>

              <div className="winner-img-wrap">
                <img
                  src={winnerGift.image || DEFAULT_GIFT_IMG}
                  alt={winnerGift.name}
                  onError={(e) => { e.target.src = DEFAULT_GIFT_IMG; }}
                />
              </div>

              <h2 className="winner-gift-name">{winnerGift.name}</h2>
              
              <div className="winner-meta">
                <span className="winner-tag-badge">{winnerGift.tag || 'Quà Tặng'}</span>
                {winnerGift.purchaseUrl && (
                  <a
                    href={winnerGift.purchaseUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="winner-link-preview"
                  >
                    🔗 Xem link sản phẩm
                  </a>
                )}
              </div>

              {!isExpiredDeadline ? (
                <div className="winner-buttons">
                  <button
                    type="button"
                    className="btn-confirm-gift"
                    onClick={() => handleConfirmGiftChoice(winnerGift)}
                  >
                    ❤️ Chốt Món Này Làm Quà Của Tôi
                  </button>
                  <button
                    type="button"
                    className="btn-respin"
                    onClick={handleSpin}
                  >
                    🔄 Quay Thử Món Khác
                  </button>
                </div>
              ) : (
                <p style={{ color: '#ef4444', fontWeight: 600 }}>Sự kiện đã hết hạn chốt quà.</p>
              )}
            </div>
          </div>
        )}

        {/* 6. MODAL LỜI CHÚC Ý NGHĨA */}
        {showWishModal && confirmedRegistration && (
          <div className="gift-modal-overlay" onClick={() => setShowWishModal(false)}>
            <div className="gift-wish-modal" onClick={e => e.stopPropagation()}>
              <button
                type="button"
                className="modal-close-btn"
                onClick={() => setShowWishModal(false)}
              >
                ✕
              </button>
              <div className="wish-heart-icon">💌 🕊️ 💐</div>
              <span className="wish-badge">{userReligious === 'Tu Sĩ' ? 'Ban Giáo Lý Kính Chúc Quý Tu Sĩ' : 'Ban Giáo Lý Kính Chúc'}</span>
              <h2 className="wish-title">{confirmedRegistration.wishTitle || 'Muôn Ơn Phúc Lành'}</h2>
              
              <div className="wish-message-box">
                <p>"{confirmedRegistration.wishContent}"</p>
              </div>

              <div className="wish-gift-summary">
                <img
                  src={confirmedRegistration.giftImage || DEFAULT_GIFT_IMG}
                  alt={confirmedRegistration.giftName}
                  onError={(e) => { e.target.src = DEFAULT_GIFT_IMG; }}
                />
                <div>
                  <strong>{confirmedRegistration.giftName}</strong>
                  {confirmedRegistration.purchaseUrl && (
                    <a
                      href={confirmedRegistration.purchaseUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="wish-view-link"
                    >
                      🔗 Link mua hàng
                    </a>
                  )}
                </div>
              </div>

              <button
                type="button"
                className="btn-wish-done"
                onClick={() => setShowWishModal(false)}
              >
                {userReligious === 'Tu Sĩ' ? 'Tạ Ơn Chúa ❤️' : 'Cảm Ơn Ban Giáo Lý ❤️'}
              </button>
            </div>
          </div>
        )}

        {/* 7. MODAL THÊM QUÀ TỰ CHỌN CỦA GLV */}
        {showManageModal && (
          <div className="gift-modal-overlay" onClick={() => setShowManageModal(false)}>
            <div className="gift-manage-modal" onClick={e => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Thêm Món Quà Bạn Yêu Thích</h3>
                <button className="modal-close-btn" onClick={() => setShowManageModal(false)}>✕</button>
              </div>

              <form onSubmit={handleAddCustomGift} className="add-gift-form">
                <input
                  type="text"
                  placeholder="Nhập tên món quà bạn muốn..."
                  value={newGiftName}
                  onChange={e => setNewGiftName(e.target.value)}
                  className="gift-input"
                  maxLength={60}
                  required
                />

                <input
                  type="text"
                  placeholder="Ghi chú phân loại (Ví dụ: Thích nhất, Tiện lợi, Tự chọn...)"
                  value={newGiftTag}
                  onChange={e => setNewGiftTag(e.target.value)}
                  className="gift-input"
                />

                {/* Ô NHẬP LINK MUA HÀNG */}
                <input
                  type="url"
                  placeholder="Link mua hàng (nếu có, ví dụ: Shopee, Tiki, Lazada, website...)"
                  value={newPurchaseUrl}
                  onChange={e => setNewPurchaseUrl(e.target.value)}
                  className="gift-input"
                />

                <button type="submit" className="btn-add-submit" disabled={isSubmitting}>
                  {isSubmitting ? 'Đang lưu...' : '➕ Thêm Vào Danh Sách Quà Của Tôi'}
                </button>
              </form>

              <div className="custom-gifts-list">
                <h4>Món quà bạn đã tự thêm ({customGifts.length}):</h4>
                {customGifts.length === 0 ? (
                  <p className="empty-msg">Chưa có món nào được thêm.</p>
                ) : (
                  customGifts.map(g => (
                    <div key={g.id} className="custom-gift-row">
                      <img
                        src={g.image || DEFAULT_GIFT_IMG}
                        alt={g.name}
                        onError={(e) => { e.target.src = DEFAULT_GIFT_IMG; }}
                      />
                      <div className="custom-gift-info">
                        <strong>{g.name}</strong>
                        <span>Phân loại: {g.tag}</span>
                        {g.purchaseUrl && (
                          <a 
                            href={g.purchaseUrl} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="custom-row-link"
                          >
                            🔗 Xem link mua hàng
                          </a>
                        )}
                      </div>
                      <button
                        type="button"
                        className="btn-del-custom"
                        onClick={() => handleDeleteCustomGift(g.id)}
                        title="Xoá món này"
                      >
                        🗑️
                      </button>
                    </div>
                  ))
                )}
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn-done-manage"
                  onClick={() => setShowManageModal(false)}
                >
                  Hoàn Tất
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default CatechistGiftRoulette;